// src/components/CreateProductModal/CreateProductModal.js
// Two-option choice modal: Upload COA or Order Tests
import React from "react";
import "./CreateProductModal.css";
import { useEscapeKey } from "../ui/useEscapeKey";

const CreateProductModal = ({ onClose, onSelectUpload, onSelectOrderTests }) => {
    useEscapeKey(onClose);
    return (
        <div className="cpm-backdrop" onClick={onClose} role="dialog" aria-modal="true">
            <div className="cpm" onClick={(e) => e.stopPropagation()}>
                <div className="cpm__header">
                    <h3 className="cpm__title">Create Product</h3>
                    <button className="cpm__close" onClick={onClose} aria-label="Close">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button> 
                </div>

                <div className="cpm__body">
                    <p className="cpm__desc">
                        How would you like to add a product to your inventory?
                    </p>

                    <div className="cpm__options">
                        <button className="cpm__option" onClick={onSelectUpload}>
                            <span className="cpm__option-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                    <polyline points="14 2 14 8 20 8"/>
                                    <line x1="12" y1="18" x2="12" y2="12"/>
                                    <line x1="9" y1="15" x2="15" y2="15"/>
                                </svg>
                            </span>
                            <div className="cpm__option-text">
                                <span className="cpm__option-title">Upload COA</span>
                                <span className="cpm__option-desc">
                                    Upload a PDF certificate of analysis to add a tested product
                                </span>
                            </div>
                            <span className="cpm__option-arrow">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                        </button>

                        <button className="cpm__option" onClick={onSelectOrderTests}>
                            <span className="cpm__option-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M9 11l3 3L22 4"/>
                                    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
                                </svg>
                            </span>
                            <div className="cpm__option-text">
                                <span className="cpm__option-title">Order Tests</span>
                                <span className="cpm__option-desc">
                                    Send a product to a lab partner for testing and analysis
                                </span>
                            </div>
                            <span className="cpm__option-arrow">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateProductModal;
